export enum InjectionUsage {
    AllMeters = 'allMeters', // for analog and digital meters
    DigitalMeters = 'digitalMeters', // only for digital meters
}
